import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.label,
      'item': item.path ? `https://www.qiyoucinema.com${item.path}` : `https://www.qiyoucinema.com${location.pathname}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 py-3">
        <ol className="max-w-7xl mx-auto flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <span className="w-3 h-3 flex items-center justify-center text-foreground-600">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.path && index < items.length - 1 ? (
                <Link to={item.path} className="hover:text-primary-400 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'text-foreground-300 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}